module.exports = __webpack_public_path__ + "static/media/CARLogoPrimary.16cd0fe1.png";